const home = {
	pageTitle: "Home Page",
};

export default home;
